export class Company {
  public constructor(
    public id = 0,
    public name = "",
    public image = "",
    public codeTransport = "",
    public codeLogistic = "",
    public lang = "",
    public disabledRoute = "",
    public transportByTempo = "",
    public optionPalette = false,
    public integrateStepZero = false
  ) {}
}
